const DEFAULT_COUNT = 0;

function parse(number) {
  return parseInt(String(number).replace(/\D/g, ''), 10) || 0;
}

export default function tooShort(value = '', options = {}) {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  const count = options.count || DEFAULT_COUNT;

  if (value.length >= parse(count)) {
    return false;
  }

  return true;
}

tooShort.message = function message(value, options = {}) {
  const count = options.count || DEFAULT_COUNT;

  return `precisa ter ${count} ou mais caracteres`;
};
